import { PaletteOptions } from "@material-ui/core/styles/createPalette";

export const palette: PaletteOptions = {
  text: {
    primary: "#000000",
    secondary: "#494949"
  },
  primary: {
    main: "#000000",
    light: "#555555",
    dark: "#494949",
    contrastText: "#ffffff"
  },
  secondary: {
    main: "#adaaaa"
  }
};
